<footer class="footer mb-3 db-auth__footer">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 text-center">
        <div class="text-center">
          <p class="mb-0 text-muted">
            &copy; {{year}} {{ 'COMMON.DEBEN' | translate }} {{ 'COMMON.All_RIGHTS_RESERVED' | translate }}
            <a routerLink="/terms-and-conditions" target="_blank" rel="noopener"
              class="text-primary text-decoration-underline fs-14 fw-medium db-auth__link">
              {{'COMMON.TERMS_OF_USE' | translate}}
            </a>,
            <a routerLink="/privacy-policy" target="_blank" rel="noopener"
              class="text-primary text-decoration-underline fs-14 fw-medium db-auth__link">
              {{'COMMON.PRIVACY_NOTICE' | translate}}
            </a>
          </p>
          <p class="mb-0 text-muted">
            {{'COMMON.PROTECTED_BY' | translate}} {{'COMMON.RECAPTCHA' | translate}}
            <span>{{'COMMON.TERMS_APPLY_AR' | translate}}</span>
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener"
              class="text-primary text-decoration-underline fs-14 fw-medium db-auth__link">
              {{'COMMON.GOOGLE_PRIVACY_POILICY' | translate}}
            </a>
            <span> {{'COMMON.AND' | translate}} </span>
            <a href="https://policies.google.com/terms" target="_blank" rel="noopener"
              class="text-primary text-decoration-underline fs-14 fw-medium db-auth__link">
              {{'COMMON.TERMS_OF_SERVICE' | translate}}
            </a>
            <span>{{'COMMON.TERMS_APPLY_EN' | translate}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</footer>
